module.exports = __webpack_public_path__ + "47eea112010014b1f4ef119abe3e7e77.svg";